import React, { useState } from "react";
import { Modal, Button, Form, Space, Result, Select, DatePicker } from "antd";
import { useStepsForm } from "sunflower-antd";

import { SelectProps } from "antd/lib/select";

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleLapse?: Function | undefined;
  memberId: any;
}

const lapseReasons: SelectProps["options"] = [
  {
    name: "Manual Lapse",
    label: "Manual Lapse",
    value: "Manual Lapse",
  },
  {
    name: "Not Taken Up",
    label: "Not Taken Up",
    value: "Not Taken Up",
  },
];

const LapsePolicyModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleLapse,
  memberId,
  // documents,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);
      if (handleLapse != undefined) {
        const response = await handleLapse(memberId, values);

        if (response.success) {
          setLoading(false);
          return true;
        }
        setErrorMsg(response.message);
        setLoading(false);
        return false;
      }
    },
    total: 3,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const display: any = {
    0: (
      <>
        <Form.Item
          name="LapsedDate"
          label="Lapse Date"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker
            id="LapsedDate"
            placeholder="Lapse Date"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item name="LapsedReason" label="Lapse Reason">
          <Select
            id="LapsedReason"
            options={lapseReasons}
            size="large"
            style={{ width: "100%" }}
            placeholder="Lapse Reason"
          />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button
              loading={loading}
              style={{ marginBottom: 10 }}
              block
              size="large"
              onClick={() => {
                submit().then((result: any) => {
                  if (result) {
                    gotoStep(current + 1);
                  } else if (!result) {
                    gotoStep(current + 2);
                  }
                });
              }}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </>
    ),
  };

  return (
    <Modal
      title="Lapse Policy"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        {current === 1 && <></>}
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {display[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully Lapsed Policy.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default LapsePolicyModal;
